/**
 * 将后端返回的 HTTP / 内网静态资源 URL 转为可在当前页面安全加载的地址。
 * HTTPS 页面加载 http:// 图片会被浏览器 mixed-content 拦截。
 * 本地开发相对路径没有静态资源服务，拼到 deepsage.app。
 */
const FALLBACK_MEDIA_ORIGIN = 'https://deepsage.app';

function isSecurePage() {
  return typeof window !== 'undefined' && window.location?.protocol === 'https:';
}

function isLocalDevHost() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local');
}

export function resolveMediaOrigin() {
  if (typeof window === 'undefined' || isLocalDevHost()) return FALLBACK_MEDIA_ORIGIN;
  return window.location.origin;
}

function withMediaOrigin(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (!isLocalDevHost()) return normalized;
  return `${resolveMediaOrigin()}${normalized}`;
}

function extractStaticsPath(url) {
  const raw = String(url ?? '').trim();
  if (!raw) return '';

  try {
    const pathname = raw.startsWith('/') ? raw : new URL(raw).pathname;
    const idx = pathname.indexOf('/statics/');
    if (idx === -1) return '';
    return pathname.slice(idx);
  } catch {
    const match = raw.match(/\/statics\/[^\s?#]+/);
    return match ? match[0] : '';
  }
}

/**
 * @param {string} url
 * @returns {string}
 */
export function resolveMediaUrl(url) {
  const raw = String(url ?? '').trim();
  if (!raw) return '';
  if (raw.startsWith('blob:') || raw.startsWith('data:')) return raw;
  if (raw.startsWith('//')) {
    return isSecurePage() ? `https:${raw}` : `http:${raw}`;
  }

  if (raw.startsWith('/')) return withMediaOrigin(raw);

  const staticsPath = extractStaticsPath(raw);
  if (staticsPath) {
    if (isSecurePage()) return withMediaOrigin(staticsPath);
    return raw;
  }

  if (raw.startsWith('https://')) return raw;

  if (raw.startsWith('http://')) {
    if (!isSecurePage()) return raw;
    try {
      const parsed = new URL(raw);
      if (typeof window !== 'undefined' && parsed.hostname === window.location.hostname) {
        return `https://${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
      }
    } catch {
      // ignore
    }
    return '';
  }

  if (!/^[a-z][a-z0-9+.-]*:/i.test(raw)) {
    return withMediaOrigin(raw);
  }

  return raw;
}
